import { gql } from "@apollo/client";

export default gql`
  mutation deleteEmailAdminLogs($params: DeleteEmailAdminLogsInput!){
    deleteEmailAdminLogs(params: $params){
        success
        data{
            deletedCount
        }
        code
        message
    }
}
`
